/** `/c/$companyId/purchases/credits/new?creditOf&supplier` — a new supplier credit, created on its first save. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SupplierDocPage } from "../bills/page/SupplierDocPage";

const search = z.object({
  creditOf: z.string().uuid().optional().catch(undefined),
  supplier: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/credits/new")({
  validateSearch: (raw) => search.parse(raw),
  component: NewCreditRoute,
});

function NewCreditRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { creditOf, supplier } = Route.useSearch();
  return (
    <SupplierDocPage
      companyId={companyId}
      kind="vendor-credits"
      creditOf={creditOf}
      supplier={supplier}
    />
  );
}
